export {Text as default} from "@hosttools/frontend/components/index.web";
export {type ITextProps} from "@hosttools/frontend/components/ui/text/types";
